import React from 'react';
import { ScrollBarsLike } from '../Scrollbar';

type ScrollParent = ScrollBarsLike;

export const ScrollParentContext = React.createContext<ScrollParent[]>([]);
